










export default {
	name: 'TextTab',
	methods: {
		async updateJobsNavSwitch() {
			if (this.text == 'Job Info') {
				await this.$store.dispatch('jobs/single/updateJobsNavSwitch', true);
				await this.$store.dispatch('jobs/single/updateCandidatesNavSwitch', false);
			} else {
				await this.$store.dispatch('jobs/single/updateJobsNavSwitch', false);
				await this.$store.dispatch('jobs/single/updateCandidatesNavSwitch', true);
			}
		},
	},
	props: {
		text: {
			required: true,
			type: String,
		},
		tab: {
			default: 'all',
			required: true,
			type: String,
		},
		active: {
			default: false,
			required: false,
			type: Boolean,
		},
	},
};
